import { PreferenceForm } from "../preference-form/preference-form.model";
import { Serializer } from "../resource/serializer.interface";
import { PreferencePage } from "./preference-page.model";

export class PreferencePageSerializer implements Serializer {
    fromJson(json: any): PreferencePage {
        const preferencePage = new PreferencePage();
        preferencePage.id = json.id;
        preferencePage.name = json.name;
        preferencePage.description = json.description;
        preferencePage.status = json.status;
        preferencePage.form_Id = json.form_Id;
        preferencePage.html = json.html;
        preferencePage.headerHtml = json.headerHtml;
        preferencePage.footerHtml = json.footerHtml;
        preferencePage.customCss = json.customCss;
        preferencePage.headerScript = json.headerScript;
        preferencePage.footerScript = json.footerScript;
        preferencePage.businessUnit = json.businessUnit;
        preferencePage.i18nLanguage = json.i18n_language;
        preferencePage.tenantId = json.tenant_id;
        preferencePage.generalCorePreferences = json.generalCorePreferences;
        preferencePage.includeEmailSearch = json.includeEmailSearch;
        preferencePage.includeUnsubscribe = json.includeUnsubscribe;
        preferencePage.controlId = json.controlId;
        preferencePage.redirectUrl = json.redirectUrl;
        preferencePage.advancedHtml = json.advancedHtml;
        preferencePage.isAdvancedMode = json.isAdvancedMode;
        preferencePage.uiTranslations = json.uiTranslations ?? {};

        return preferencePage;
    }

    toJson(preferencePage: PreferencePage): any {
        return {
            id: preferencePage.id,
            name: preferencePage.name,
            description: preferencePage.description,
            status: preferencePage.status,
            form_id: preferencePage.form_Id,
            html: preferencePage.html,
            headerHtml: preferencePage.headerHtml,
            footerHtml: preferencePage.footerHtml,
            customCss: preferencePage.customCss,
            headerScript: preferencePage.headerScript,
            footerScript: preferencePage.footerScript,
            businessUnit: preferencePage.businessUnit,
            i18n_language: preferencePage.i18nLanguage,
            tenant_id: preferencePage.tenantId,
            generalCorePreferences: preferencePage.generalCorePreferences,
            includeEmailSearch: preferencePage.includeEmailSearch,
            includeUnsubscribe: preferencePage.includeUnsubscribe,
            controlId: preferencePage.controlId,
            redirectUrl: preferencePage.redirectUrl,
            advancedHtml: preferencePage.advancedHtml,
            isAdvancedMode: preferencePage.isAdvancedMode,
            uiTranslations: preferencePage.uiTranslations
        };
    }
}
